import { phone } from "phone";
import { toast } from "react-toastify";
import { ERR_NETWORK } from "./messages";

export const isNumberString = (data) => {
  return /^\d+$/.test(data);
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validatePhoneNumber = (number) => {
  return phone(number)?.isValid ?? false;
};

export const getObjectItem = (data = {}, selector = "") => {
  const type = typeof selector;
  if (type === "string") return data?.[selector];
  if (type === "function") return selector(data);
  return null;
};

export const formatArray = (data) => (Array.isArray(data) ? data : []);

export const convertId2String = (data = []) =>
  (data ?? []).map((item = {}) => ({
    ...(item ?? {}),
    id: String(item?.id ?? ""),
  }));

export const loopSelf = (
  data = [],
  onEach = () => {},
  onFinish = () => {},
  current = 0
) => {
  if (current < data?.length) {
    onEach(
      // next
      () => {
        loopSelf(data, onEach, onFinish, current + 1);
      },
      // current item
      data?.[current],
      // current index
      current,
      // self
      data
    );
  } else {
    onFinish();
  }
};

export const modifyArray = (data = [], index = 0, modifyItem = {}) => {
  const newArray = [
    ...data.slice(0, index),
    modifyItem,
    ...data.slice(index + 1),
  ];
  return newArray;
};

export const removeItemArray = (data = [], index = 0) => {
  const newArray = [...data.slice(0, index), ...data.slice(index + 1)];
  return newArray;
};

export const addItemArray = (data = [], newItem = {}) => {
  const newArray = [...data, newItem];
  return newArray;
};

export const groupBy = (array, key) => {
  // Return the end result
  return array
    ?.filter((item) => item)
    .reduce((result, currentValue) => {
      // If an array already present for key, push it to the array. Else create an array and push the object
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
      return result;
    }, {}); // empty object is the initial value for result object
};

export function isJSONValid(text) {
  try {
    JSON.parse(text);
  } catch (e) {
    return false;
  }
  return true;
}
export function isJSONArray(text) {
  if (!isJSONValid(text)) return false;
  let t = JSON.parse(text);
  if (t?.length >= 0) return true;
  else return false;
}

export const formatJSONString = (str, isArray = false) => {
  if (Boolean(isArray)) {
    return isJSONArray(String(str)) ? String(str) : "[]";
  } else {
    return isJSONValid(String(str)) ? String(str) : "{}";
  }
};

export const jsonParse = (str, isArray = false) => {
  return JSON.parse(formatJSONString(str, isArray));
};

export const notify = ({ variant = "success", message = "" }) => {
  switch (variant) {
    case "success": {
      toast.success(message);
      break;
    }
    case "info": {
      toast.info(message);
      break;
    }
    case "warning": {
      toast.warning(message);
      break;
    }
    default:
      toast.error(message);
      break;
  }
};

export const errorAction = (res, err) => {
  if (!res && err?.message) {
    return notify({ message: err?.message, variant: "warning" });
  } else {
    return notify({ message: ERR_NETWORK.LONG, variant: "warning" });
  }
};
